import axios from "axios";

export const PASSING_THRESHOLD = 8.0;

/**
 * Extracts the real average score (scale 1 to 10) from the backend applicant evaluations.
 * Reads cards scores from 'behavioral_preferences' or the latest completed evaluation.
 * @param {Object} applicantData Response from /applicants/:id/responses/disc
 * @returns {number|null} Score from 1.0 to 10.0, or null if cards/evaluations not present
 */
export const getRealEvaluationScore = (applicantData) => {
    if (!applicantData || !Array.isArray(applicantData.evaluations)) return null;

    const evalObj = applicantData.evaluations
        .slice()
        .reverse()
        .find(e => e.result && Array.isArray(e.result.cards));

    if (!evalObj || !evalObj.result.cards.length) return null;

    const cards = evalObj.result.cards;
    const scores = cards.map(c => Number(c.score)).filter(s => !isNaN(s));

    if (!scores.length) return null;

    const average = scores.reduce((sum, val) => sum + val, 0) / scores.length;
    return Math.round(average * 10) / 10;
};

export const evaluateResponsesService = async (surveyId, responses, applicantId) => {
    const { data } = await axios.post(`https://recruitment-be-abfba9bjhqc3hyfn.eastus-01.azurewebsites.net/applicants/${applicantId}/responses/disc`, { surveyId: surveyId, responses: responses });
    return data;
}

export const evaluateResponsesDevService = async (surveyId, responses, applicantId) => {
    const { data } = await axios.post(`https://recruitment-be-dev-ghhbe8acadbtbkej.eastus-01.azurewebsites.net/applicants/${applicantId}/responses/disc`, { surveyId: surveyId, responses: responses });
    return data;
}

export const checkEvaluationService = async (applicantId) => {
    const { data } = await axios.get(`https://recruitment-be-abfba9bjhqc3hyfn.eastus-01.azurewebsites.net/api/applicants/${applicantId}/evaluation/check`);
    return data;
}

export const checkEvaluationDevService = async (applicantId) => {
    const { data } = await axios.get(`https://recruitment-be-dev-ghhbe8acadbtbkej.eastus-01.azurewebsites.net/api/applicants/${applicantId}/evaluation/check`);
    return data;
}

export const getApplicantDevService = async (applicantId) => {
    const { data } = await axios.get(`https://recruitment-be-dev-ghhbe8acadbtbkej.eastus-01.azurewebsites.net/applicants/${applicantId}`);
    return data;
}

export const sendDocumentRequestService = async (applicantId) => {
    const { data } = await axios.post(`https://recruitment-be-abfba9bjhqc3hyfn.eastus-01.azurewebsites.net/api/applicants/${applicantId}/send-document-request`);
    return data;
}

export const sendInterviewInvitationService = async (applicantId) => {
    const { data } = await axios.post(`https://recruitment-be-abfba9bjhqc3hyfn.eastus-01.azurewebsites.net/api/applicants/${applicantId}/send-interview-invitation`);
    return data;
}

export const sendDocumentRequestDevService = async (applicantId) => {
    const { data } = await axios.post(`https://recruitment-be-dev-ghhbe8acadbtbkej.eastus-01.azurewebsites.net/api/applicants/${applicantId}/send-document-request`);
    return data;
}

export const sendInterviewInvitationDevService = async (applicantId) => {
    const { data } = await axios.post(`https://recruitment-be-dev-ghhbe8acadbtbkej.eastus-01.azurewebsites.net/api/applicants/${applicantId}/send-interview-invitation`);
    return data;
}

export const scheduleApplicantRejectionService = async (applicantId, reason = "survey_score_low", note = "Rechazo automático por puntaje en test", delayHours = 24) => {
    const { data } = await axios.post(`https://recruitment-be-abfba9bjhqc3hyfn.eastus-01.azurewebsites.net/api/applicants/${applicantId}/schedule-rejection`, {
        delay_hours: delayHours,
        reason: reason,
        note: note
    });
    return data;
}

export const scheduleApplicantRejectionDevService = async (applicantId, reason = "survey_score_low", note = "Rechazo automático por puntaje en test", delayHours = 24) => {
    const { data } = await axios.post(`https://recruitment-be-dev-ghhbe8acadbtbkej.eastus-01.azurewebsites.net/api/applicants/${applicantId}/schedule-rejection`, {
        delay_hours: delayHours,
        reason: reason,
        note: note
    });
    return data;
}

export const sendWhatsAppDocumentTemplateService = async (applicantId, language = "es") => {
    const { data } = await axios.post(`https://recruitment-be-abfba9bjhqc3hyfn.eastus-01.azurewebsites.net/api/whatsapp/templates/send`, {
        applicant_ids: [applicantId],
        template_number: 29,
        language: language,
        body: [
            "{{candidate_first_name}}",
            "{{applicant_id}}"
        ]
    });
    return data;
}

export const sendWhatsAppDocumentTemplateDevService = async (applicantId, language = "es") => {
    const { data } = await axios.post(`https://recruitment-be-dev-ghhbe8acadbtbkej.eastus-01.azurewebsites.net/api/whatsapp/templates/send`, {
        applicant_ids: [applicantId],
        template_number: 29,
        language: language,
        body: [
            "{{candidate_first_name}}",
            "{{applicant_id}}"
        ]
    });
    return data;
}


